/* Pip & Wells theme — vanilla JS, no dependencies.
   Motion: reveal, split headlines, ribbon, parallax, magnetic buttons, pointer glow.
   Commerce: AJAX cart + drawer, quick add, variant picker, add-ons, sticky buy, predictive search. */
(function () {
  'use strict';
  const PW = window.PW || { routes: {}, strings: {} };
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Money ---------- */
  function money(cents) {
    const fmt = PW.money || '€{{amount_with_comma_separator}}';
    const n = (cents / 100);
    const withComma = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withDot = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDec = Math.round(n).toString();
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }
  window.PW.formatMoney = money;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg, type) {
    const el = $('#pw-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('pw-toast--error', type === 'error');
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }
  window.PW.toast = toast;

  /* ---------- Page veil ---------- */
  const veil = $('.page-veil');
  if (veil) requestAnimationFrame(() => setTimeout(() => veil.classList.add('is-done'), 60));

  /* ---------- Reveal on scroll ---------- */
  function splitWords(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    const walk = (node) => {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === 3) {
          const words = child.textContent.split(/(\s+)/);
          const frag = document.createDocumentFragment();
          words.forEach((w) => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(' ')); return; }
            const outer = document.createElement('span'); outer.className = 'split-word';
            const inner = document.createElement('span'); inner.textContent = w;
            outer.appendChild(inner); frag.appendChild(outer);
          });
          child.replaceWith(frag);
        } else if (child.nodeType === 1 && !child.classList.contains('split-word')) walk(child);
      });
    };
    walk(el);
    $$('.split-word > span', el).forEach((s, i) => (s.style.setProperty('--d', (i * 55) + 'ms')));
    el.classList.add('split-ready');
  }
  function initReveal() {
    const items = $$('[data-reveal], [data-stagger], [data-split]');
    if (!items.length) return;
    $$('[data-split]').forEach(splitWords);
    if (reduce || !('IntersectionObserver' in window)) { items.forEach((i) => i.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((i) => io.observe(i));
  }

  /* ---------- Ribbon (pause when hidden / toggle) ---------- */
  function initRibbons() {
    $$('.ribbon-wrap').forEach((wrap) => {
      const svg = $('.ribbon', wrap); const btn = $('.ribbon-toggle', wrap);
      if (!svg) return;
      let paused = false, visible = true;
      const apply = () => svg.dataset.running = String(!paused && visible && !reduce);
      if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visible = !!e.isIntersecting; apply(); }).observe(wrap);
      document.addEventListener('visibilitychange', () => { visible = document.visibilityState === 'visible'; apply(); });
      if (btn) btn.addEventListener('click', () => {
        paused = !paused; apply(); btn.setAttribute('aria-pressed', paused);
        $('.ribbon-toggle__label', btn).textContent = paused ? btn.dataset.resume : btn.dataset.pause;
        $('.ribbon-toggle__pause', btn).classList.toggle('hidden', paused);
        $('.ribbon-toggle__play', btn).classList.toggle('hidden', !paused);
      });
      apply();
    });
  }

  /* ---------- Parallax + pointer glow + magnetic ---------- */
  function initParallax() {
    if (reduce) return;
    const els = $$('.parallax');
    if (!els.length) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * -1 * (parseFloat(el.dataset.parallax) || 18)) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }
  function initGlow() {
    if (!finePointer || reduce) return;
    $$('.has-glow').forEach((sec) => {
      sec.addEventListener('pointermove', (e) => {
        const r = sec.getBoundingClientRect();
        sec.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        sec.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
        sec.classList.add('is-glow');
      });
      sec.addEventListener('pointerleave', () => sec.classList.remove('is-glow'));
    });
  }
  function initMagnetic() {
    if (!finePointer || reduce) return;
    $$('.magnetic').forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.28;
        el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      el.addEventListener('pointerleave', () => (el.style.transform = ''));
    });
  }

  /* ---------- Count-up ---------- */
  function initCountUp() {
    $$('.count-up').forEach((el) => {
      const target = parseFloat(el.dataset.count); const dec = (el.dataset.decimals | 0);
      if (isNaN(target) || reduce) return;
      const run = () => {
        const start = performance.now(), dur = 1400;
        const tick = (t) => {
          const p = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * e).toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };
      if ('IntersectionObserver' in window) { const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { run(); io.disconnect(); } }); io.observe(el); } else run();
    });
  }

  /* ---------- Header hide/show ---------- */
  function initHeader() {
    const header = $('.header'), inner = $('.header__inner', header || document);
    const access = $('.pw-sub-access-bar');
    if (header && inner) {
      let queued = false;
      const fit = () => {
        queued = false;
        // Measure the full row without painting an intermediate state. Locale labels
        // and fonts vary; keep the existing full navigation whenever it actually fits.
        header.classList.remove('pw-header-compact', 'pw-header-stacked');
        if (window.innerWidth >= 1280) {
          const style = getComputedStyle(inner);
          const items = [...inner.children].filter(el => el.getClientRects().length);
          const needed = items.reduce((sum, el) => sum + el.getBoundingClientRect().width, 0)
            + (parseFloat(style.columnGap) || 0) * Math.max(0, items.length - 1)
            + (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
          if (needed > inner.clientWidth + 1) {
            header.classList.add('pw-header-stacked');
            const nav = $('.header__nav', header);
            // A second row keeps the shopping links visible before using the menu.
            if (nav && nav.scrollWidth > nav.clientWidth + 1) {
              header.classList.remove('pw-header-stacked');
              header.classList.add('pw-header-compact');
            }
          }
        }
        document.documentElement.style.setProperty('--pw-home-header-height',
          (header.getBoundingClientRect().height + (access?.getBoundingClientRect().height || 0)) + 'px');
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(fit); } };
      fit();
      window.addEventListener('resize', schedule, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(schedule);
        observer.observe(inner);
        if (access) observer.observe(access);
      }
      document.fonts?.ready.then(schedule);
    }
    const group = $('.shopify-section-group-header-group'); if (!group) return;
    let last = window.scrollY, ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y > 140 && y > last + 4 && !document.body.classList.contains('drawer-open')) group.classList.add('is-hidden');
        else if (y < last - 4 || y < 140) group.classList.remove('is-hidden');
        last = y; ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Drawers ---------- */
  const drawers = {};
  /* Perf: the drawer opens synchronously (content is already server-rendered; refreshCart fills it
     afterwards). Layers are promoted on pointerdown (.is-warm) so the first frame of the slide does not
     wait for rasterisation, will-change is dropped again after the transition, and focus waits for the
     transition to end (focusing a qty input mid-slide popped the mobile keyboard / forced scroll). */
  function settle(d) {
    const done = () => { d.classList.remove('is-anim'); };
    clearTimeout(d._pwAnim); d._pwAnim = setTimeout(done, 520);
  }
  function openDrawer(id) {
    const d = $('#' + id); if (!d) return;
    Object.keys(drawers).forEach((k) => { if (k !== id) closeDrawer(k); });
    if (d.classList.contains('is-open')) return;
    d.classList.add('is-anim', 'is-open'); d.classList.remove('is-warm'); d.removeAttribute('aria-hidden');
    d._pwOpenedAt = performance.now();
    document.body.classList.add('drawer-open');
    drawers[id] = document.activeElement;
    requestAnimationFrame(() => { if (d.classList.contains('is-open')) document.body.style.overflow = 'hidden'; });
    settle(d);
    const f = id === 'CartDrawer' ? $('button.drawer__close', d) : $$('[autofocus], input, button.drawer__close, button[data-close-drawer]', d).find(el => el.getClientRects().length);
    if (f) setTimeout(() => { if (d.classList.contains('is-open')) f.focus({ preventScroll: true }); }, 440);
  }
  function closeDrawer(id) {
    const d = $('#' + id); if (!d || !d.classList.contains('is-open')) return;
    d.classList.add('is-anim'); d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    settle(d);
    if (!$('.drawer.is-open, .mobile-menu.is-open')) { document.body.classList.remove('drawer-open'); document.body.style.overflow = ''; }
    const prev = drawers[id]; delete drawers[id]; if (prev && prev.focus) prev.focus({ preventScroll: true });
  }
  /* Warm-up on touch/pointer down: promote + raster the drawer layers ~100ms before the click fires. */
  document.addEventListener('pointerdown', (e) => {
    const t = e.target.closest && e.target.closest('[data-open-drawer]'); if (!t) return;
    const d = $('#' + t.dataset.openDrawer); if (!d || !d.classList.contains('drawer') || d.classList.contains('is-open')) return;
    d.classList.add('is-warm');
    clearTimeout(d._pwWarm); d._pwWarm = setTimeout(() => d.classList.remove('is-warm'), 900);
  }, { passive: true });
  /* Touch: start the slide on pointerup instead of waiting for the click, whose dispatch also runs
     third-party analytics listeners (~100ms+ on mid-range phones). A scroll gesture fires pointercancel,
     not pointerup, so scrolling over the icon never opens the drawer. */
  document.addEventListener('pointerup', (e) => {
    if (e.pointerType === 'mouse' || e.button > 0) return;
    const t = e.target.closest && e.target.closest('[data-open-drawer]'); if (!t) return;
    const d = $('#' + t.dataset.openDrawer); if (!d || !d.classList.contains('drawer')) return;
    openDrawer(t.dataset.openDrawer);
  }, { passive: true });
  window.PW.openDrawer = openDrawer; window.PW.closeDrawer = closeDrawer;
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-drawer]'); if (open) { e.preventDefault(); openDrawer(open.dataset.openDrawer); return; }
    const close = e.target.closest('[data-close-drawer]'); if (close) {
      // Links still navigate after closing; buttons and backdrops only close.
      if (!close.matches('a[href]')) e.preventDefault();
      // The click that follows a touch-open (pointerup) can hit-test onto the fresh backdrop: ignore it.
      const host = close.closest('.drawer'); if (host && host._pwOpenedAt && performance.now() - host._pwOpenedAt < 400 && !close.matches('a[href]')) return;
      closeDrawer(close.dataset.closeDrawer || close.closest('.drawer, .mobile-menu').id);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open, .mobile-menu.is-open').forEach((d) => closeDrawer(d.id)); });
  // Keep keyboard navigation inside the currently open modal drawer.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || e.defaultPrevented) return;
    const modal = $('.drawer.is-open, .mobile-menu.is-open'); if (!modal) return;
    const focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex="0"]', modal)
      .filter(el => el.getClientRects().length && !el.closest('[hidden], [inert]'));
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Cart ---------- */
  async function fetchCart() { const r = await fetch(PW.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  let cartRefreshVersion = 0;
  async function refreshCartDrawer(open) {
    const version = ++cartRefreshVersion;
    const sectionUrl = new URL(PW.routes.cart, window.location.origin);
    sectionUrl.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
    sectionUrl.searchParams.set('_pw_cart', String(Date.now()));
    const r = await fetch(sectionUrl.pathname + sectionUrl.search, { cache: 'no-store' });
    if (!r.ok) throw new Error(PW.strings.addError);
    const data = await r.json();
    // An older response must not replace a more recent cart update.
    if (version !== cartRefreshVersion) return;
    const drawer = $('#CartDrawer');
    if (drawer && data['cart-drawer']) {
      const tmp = document.createElement('div'); tmp.innerHTML = data['cart-drawer'];
      const fresh = $('#CartDrawer', tmp);
      if (fresh) {
        const panel = $('.drawer__panel', drawer);
        const focused = drawer.contains(document.activeElement) ? document.activeElement : null;
        const focusAttrs = ['data-line-plus', 'data-line-minus', 'data-line-qty', 'data-line-remove', 'data-pw-line-plan', 'data-protection-toggle'];
        const focusAttr = focused && focusAttrs.find(attr => focused.hasAttribute(attr));
        const focusValue = focusAttr && focused.getAttribute(focusAttr);
        const detailsOpen = !!$('.pw-cart-details[open]', drawer);
        const bodyScroll = $('.drawer__body', drawer)?.scrollTop || 0;
        panel.innerHTML = $('.drawer__panel', fresh).innerHTML;
        const details = $('.pw-cart-details', drawer); if (details) details.open = detailsOpen;
        const body = $('.drawer__body', drawer); if (body) body.scrollTop = bodyScroll;
        if (focused) {
          const target = focusAttr && $$('[' + focusAttr + ']', drawer).find(el => el.getAttribute(focusAttr) === focusValue);
          (target || $('button.drawer__close', drawer))?.focus({ preventScroll: true });
        }
      }
    }
    if (data['cart-icon-bubble']) {
      const tmp = document.createElement('div'); tmp.innerHTML = data['cart-icon-bubble'];
      const count = $('[data-cart-count]', tmp);
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count ? count.textContent : '0';
        el.classList.toggle('is-visible', !!(count && parseInt(count.textContent, 10) > 0));
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
    }
    if (open) openDrawer('CartDrawer');
  }
  window.PW.refreshCart = refreshCartDrawer;

  async function addToCart(items) {
    const r = await fetch(PW.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || err.message || PW.strings.addError); }
    return r.json();
  }
  window.PW.addToCart = addToCart;

  let cartChanging = false;
  async function changeLine(key, quantity, el) {
    if (cartChanging) return;
    cartChanging = true;
    const wrap = el && el.closest('.drawer__panel, .cart-page');
    const controls = wrap ? $$('[data-line-plus], [data-line-minus], [data-line-remove], [data-line-qty], [data-quick-add], [name="checkout"], [name="update"]', wrap).map(node => ({ node, disabled: node.disabled })) : [];
    controls.forEach(({ node }) => { node.disabled = true; });
    if (wrap) wrap.setAttribute('aria-busy', 'true');
    let error;
    try {
      const r = await fetch(PW.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (!r.ok) { const data = await r.json().catch(() => ({})); throw new Error(data.description || data.message || PW.strings.addError); }
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    } catch (e) { error = e; }
    try {
      if (document.body.classList.contains('template-cart')) {
        const cart = await fetchCart();
        const item = cart.items.find(line => line.key === key);
        $$('[data-line-qty]').filter(input => input.dataset.lineQty === key).forEach(input => { input.value = item ? item.quantity : 0; });
      } else await refreshCartDrawer(false);
    } catch (e) { error = error || e; }
    finally {
      controls.forEach(({ node, disabled }) => { node.disabled = disabled; });
      if (wrap) wrap.removeAttribute('aria-busy');
      cartChanging = false;
    }
    if (error) toast(error.message || PW.strings.addError, 'error');
  }

  document.addEventListener('click', async (e) => {
    const plus = e.target.closest('[data-line-plus]'); const minus = e.target.closest('[data-line-minus]'); const rm = e.target.closest('[data-line-remove]');
    if (plus || minus) {
      if (cartChanging) return;
      const btn = plus || minus; const input = $('input', btn.closest('.qty'));
      const q = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
      input.value = q; changeLine(btn.dataset.linePlus || btn.dataset.lineMinus, q, btn);
    }
    if (rm) { e.preventDefault(); changeLine(rm.dataset.lineRemove, 0, rm); }
  });
  document.addEventListener('change', (e) => {
    const inp = e.target.closest('[data-line-qty]'); if (inp) changeLine(inp.dataset.lineQty, Math.max(0, parseInt(inp.value, 10) || 0), inp);
  });

  /* Quick add (product cards) */
  /* ---------- Fragrance quick add: stay on the page, confirm after the write ---------- */
  function fragranceCartFlight(button) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const target = $$('header [data-open-drawer="CartDrawer"]').find(el => {
      const r = el.getBoundingClientRect();
      return r.width && r.height && r.bottom > 0 && r.top < window.innerHeight;
    });
    if (!target) return;
    const from = button.getBoundingClientRect(), to = target.getBoundingClientRect();
    const start = { x: from.left + from.width / 2, y: from.top + from.height / 2 };
    const end = { x: to.left + to.width / 2, y: to.top + to.height / 2 };
    const bend = { x: Math.min(window.innerWidth - 12, Math.max(start.x, end.x) + Math.min(100, window.innerWidth * .12)), y: Math.max(12, Math.min(start.y, end.y) - 55) };
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'pw-cart-flight');
    svg.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;z-index:110;pointer-events:none;overflow:visible';
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('viewBox', '0 0 ' + window.innerWidth + ' ' + window.innerHeight);
    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M ' + start.x + ' ' + start.y + ' Q ' + bend.x + ' ' + bend.y + ' ' + end.x + ' ' + end.y);
    path.setAttribute('fill', 'none'); path.setAttribute('stroke', '#b19243');
    path.setAttribute('stroke-width', '2'); path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('opacity', '.7');
    const dot = document.createElementNS(ns, 'circle');
    dot.setAttribute('r', '5'); dot.setAttribute('fill', '#b19243');
    svg.append(path, dot); document.body.appendChild(svg);
    const length = path.getTotalLength();
    path.style.strokeDasharray = String(length); path.style.strokeDashoffset = String(length);
    const duration = 720, began = performance.now();
    let frame;
    const cleanup = () => { cancelAnimationFrame(frame); svg.remove(); window.removeEventListener('resize', cleanup); };
    window.addEventListener('resize', cleanup, { once: true });
    const tick = now => {
      const progress = Math.min(1, (now - began) / duration);
      const eased = 1 - Math.pow(1 - progress, 2);
      const point = path.getPointAtLength(length * eased);
      dot.setAttribute('cx', point.x); dot.setAttribute('cy', point.y);
      path.style.strokeDashoffset = String(length * (1 - eased));
      svg.style.opacity = progress > .75 ? String((1 - progress) / .25) : '1';
      if (progress < 1) frame = requestAnimationFrame(tick);
      else {
        cleanup();
        if (target.animate) target.animate([{ boxShadow: '0 0 0 0 rgba(177,146,67,.5)' }, { boxShadow: '0 0 0 12px rgba(177,146,67,0)' }], { duration: 380, easing: 'ease-out' });
      }
    };
    frame = requestAnimationFrame(tick);
  }

  async function addFragrance(button) {
    if (button.dataset.busy || button.disabled) return;
    const original = button.innerHTML;
    button.dataset.busy = '1'; button.disabled = true; button.setAttribute('aria-busy', 'true');
    button.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
    try {
      await addToCart([{ id: Number(button.dataset.quickAdd), quantity: 1 }]);
    } catch (error) {
      button.innerHTML = original; button.disabled = false; button.removeAttribute('aria-busy'); delete button.dataset.busy;
      toast(error.message || PW.strings.addError, 'error');
      return;
    }
    button.classList.add('is-added');
    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    if (!button.matches('.product-card__add, .pw-shop-card__add')) {
      const label = document.createElement('span'); label.textContent = PW.strings.added; button.appendChild(label);
    }
    button.removeAttribute('aria-busy');
    toast((button.dataset.title || '') + ' ' + PW.strings.added);
    try { fragranceCartFlight(button); }
    catch (error) { console.warn('Cart animation unavailable; continuing cart update.'); }
    // A refresh error must not suggest retrying an add that Shopify already accepted.
    try { await refreshCartDrawer(false); }
    catch (error) {
      try {
        const cart = await fetchCart();
        $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('is-visible', cart.item_count > 0); });
      } catch (refreshError) { console.warn('Fragrance added; cart display refresh unavailable.'); }
    }
    setTimeout(() => {
      button.innerHTML = original; button.classList.remove('is-added'); button.disabled = false; delete button.dataset.busy;
    }, 1600);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]'); if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.hasAttribute('data-pw-fragrance-add')) { await addFragrance(btn); return; }
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1'; const inner = btn.innerHTML; btn.innerHTML = '<span class="spinner"></span>';
    try {
      await addToCart([{ id: parseInt(btn.dataset.quickAdd, 10), quantity: 1 }]);
      btn.classList.add('is-added'); btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20 6 9 17l-5-5"/></svg>';
      toast((btn.dataset.title || '') + ' ' + PW.strings.added);
      await refreshCartDrawer(true);
      setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = inner; }, 1600);
    } catch (err) { toast(err.message || PW.strings.addError, 'error'); btn.innerHTML = inner; }
    delete btn.dataset.busy;
  });

  /* ---------- Product form ---------- */
  function initProduct() {
    const root = $('[data-product]'); if (!root) return;
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const form = $('form[data-product-form]', root);
    const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), stockEl = $('[data-stock]', root);
    const idInput = $('input[name="id"]', form);
    const qtyInput = $('[data-qty]', root);
    const addBtn = $('[data-add]', root), stickyBtn = $('[data-add-sticky]', root), stickyPrice = $('[data-sticky-price]', root);
    const addons = new Set();
    let purchaseBusy = false;
    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];

    const selectedOptions = () => $$('.option-chips', root).map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
    function renderState() {
      const qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
      let total = (current ? current.price : 0) * qty, count = 1;
      $$('[data-addon]', root).forEach((b) => { if (addons.has(b.dataset.addon)) { total += parseInt(b.dataset.price, 10); count++; } });
      const avail = current && current.available;
      const selectedAllocation = window.PWSubscriptions?.allocation(root);
      if (stickyPrice && current) stickyPrice.textContent = selectedAllocation
        ? selectedAllocation.per_delivery_text + ' ' + window.PWSubscriptions.selector(root).dataset.priceLabel
        : money(current.price);
      const label = !avail ? root.dataset.soldOut : (window.PWSubscriptions?.label(root, count > 1) || (count > 1 ? root.dataset.addMany.replace('[count]', count).replace('[total]', money(total)) : root.dataset.addOne));
      [addBtn, stickyBtn].forEach((b) => { if (b) { b.disabled = !avail || purchaseBusy; $('[data-add-label]', b).textContent = label; } });
      const summary = $('[data-addon-summary]', root);
      if (summary) { summary.classList.toggle('hidden', count === 1); if (count > 1) summary.textContent = summary.dataset.text.replace('[count]', count - 1).replace('[total]', money(total - (current ? current.price : 0) * qty)); }
    }
    function selectVariant(v) {
      current = v; if (!v) return;
      window.PWSubscriptions?.refresh(root, v);
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.classList.remove('hidden'); } else compareEl.classList.add('hidden'); }
      if (stockEl) { stockEl.textContent = v.available ? stockEl.dataset.in : stockEl.dataset.out; stockEl.classList.toggle('product__stock--out', !v.available); }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (v.featured_media && window.PW.gallerySelect) window.PW.gallerySelect(v.featured_media.id);
      const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      renderState();
    }
    root.addEventListener('change', (e) => {
      if (e.target.closest('.option-chips')) {
        const opts = selectedOptions();
        const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
        selectVariant(v || variants.find((x) => x.options[0] === opts[0]) || current);
      }
    });
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-addon]');
      if (b) { const h = b.dataset.addon; addons.has(h) ? addons.delete(h) : addons.add(h); b.setAttribute('aria-pressed', addons.has(h)); renderState(); }
      const qp = e.target.closest('[data-qty-plus]'), qm = e.target.closest('[data-qty-minus]');
      if (qp || qm) { qtyInput.value = Math.min(20, Math.max(1, parseInt(qtyInput.value, 10) + (qp ? 1 : -1))); renderState(); }
    });
    if (qtyInput) qtyInput.addEventListener('change', renderState);
    root.addEventListener('pw:purchase-change', renderState);

    async function submit(btn) {
      if (!current || !current.available || purchaseBusy) return;
      if (window.PWSubscriptions && !window.PWSubscriptions.validate(root)) return;
      purchaseBusy = true;
      [addBtn, stickyBtn].forEach(b => { if (b) b.disabled = true; });
      btn.dataset.busy = '1'; const lbl = $('[data-add-label]', btn); const prev = lbl.textContent; lbl.innerHTML = '<span class="spinner"></span>';
      const items = [{ id: current.id, quantity: Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1) }];
      const allocation = window.PWSubscriptions?.allocation(root);
      if (allocation) items[0].selling_plan = allocation.id;
      $$('[data-addon]', root).forEach((b) => { if (addons.has(b.dataset.addon)) items.push({ id: parseInt(b.dataset.variant, 10), quantity: 1 }); });
      try {
        await addToCart(items);
        toast(items.length > 1 ? PW.strings.addedMany.replace('[count]', items.length) : (root.dataset.title + ' ' + PW.strings.added));
        addons.clear(); $$('[data-addon]', root).forEach((b) => b.setAttribute('aria-pressed', 'false'));
        await refreshCartDrawer(true);
      } catch (err) { toast(err.message || PW.strings.addError, 'error'); }
      lbl.textContent = prev; delete btn.dataset.busy; purchaseBusy = false; renderState();
    }
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(addBtn); });
    if (stickyBtn) stickyBtn.addEventListener('click', () => submit(stickyBtn));

    // Sticky buy visibility
    const sticky = $('.sticky-buy', root);
    if (sticky) sticky.classList.add('is-visible'); /* altijd zichtbaar op productpagina */

    // Gallery
    const main = $('.gallery__main', root);
    if (main) {
      const imgs = $$('img', main), thumbs = $$('.gallery__thumb', root);
      const hydrateGalleryImage = (img) => {
        if (!img || !img.dataset.gallerySrc) return;
        img.loading = 'eager';
        if (img.dataset.gallerySrcset) img.srcset = img.dataset.gallerySrcset;
        img.src = img.dataset.gallerySrc;
        delete img.dataset.gallerySrc;
        delete img.dataset.gallerySrcset;
      };
      let gallerySelection = 0;
      const select = async (id) => {
        const selected = imgs.find((i) => i.dataset.mediaId === String(id));
        if (!selected) return;
        const request = ++gallerySelection;
        selected.loading = 'eager';
        hydrateGalleryImage(selected);
        try {
          await selected.decode();
        } catch (_) {
          return; // Retain the current image when the requested image cannot load.
        }
        if (request !== gallerySelection) return;
        imgs.forEach((i) => i.classList.toggle('is-active', i === selected));
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaId === String(id)));
      };
      window.PW.gallerySelect = select;
      thumbs.forEach((t) => t.addEventListener('click', () => select(t.dataset.mediaId)));
      /* Touch swipe between images. touch-action: pan-y (CSS) keeps vertical page scroll native; we only act on
         clearly horizontal gestures (|dx| > 40px and dominant over dy) and swallow the click that follows. */
      let sx = 0, sy = 0, sid = null, swiped = false;
      main.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; sid = e.pointerId; sx = e.clientX; sy = e.clientY; swiped = false; }, { passive: true });
      main.addEventListener('pointerup', (e) => {
        if (e.pointerId !== sid) return; sid = null;
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3 || imgs.length < 2) return;
        const i = Math.max(0, imgs.findIndex((x) => x.classList.contains('is-active')));
        const next = imgs[(i + (dx < 0 ? 1 : -1) + imgs.length) % imgs.length];
        if (next) { const n = next; if (n.loading === 'lazy') n.loading = 'eager'; select(n.dataset.mediaId); swiped = true; setTimeout(() => { swiped = false; }, 400); }
      }, { passive: true });
      main.addEventListener('pointercancel', () => { sid = null; }, { passive: true });
      main.addEventListener('click', (e) => { if (swiped) { swiped = false; e.stopImmediatePropagation(); e.preventDefault(); } }, true);
      const lb = $('.lightbox', root);
      /* The gallery column keeps a filled transform animation (pw-hero-in, fill:both in layout/theme.liquid),
         which makes it the containing block for position:fixed children: the lightbox only covered the
         gallery. Portal the lightbox to <body> and drop the finished entrance animation. */
      if (lb && lb.parentElement !== document.body) document.body.appendChild(lb);
      $$(':scope > [data-reveal]', $('.product', root) || root).forEach((el) => {
        const drop = () => { if (el.classList.contains('is-in') && !(el.getAnimations ? el.getAnimations() : []).some((a) => a.animationName === 'pw-hero-in' && a.playState === 'running')) el.style.animation = 'none'; };
        el.addEventListener('animationend', (ev) => { if (ev.target === el) drop(); });
        setTimeout(drop, 2500);
      });
      if (lb) {
        const close = () => {
          if (!lb.classList.contains('is-open')) return;
          lb.classList.remove('is-open');
          lb.setAttribute('aria-hidden', 'true');
          main.focus({ preventScroll: true });
        };
        lb.setAttribute('aria-hidden', 'true');
        main.addEventListener('click', () => {
          const a = $('img.is-active', main); if (!a) return;
          const zoomImage = $('img', lb);
          zoomImage.removeAttribute('srcset');
          zoomImage.removeAttribute('sizes');
          zoomImage.src = a.dataset.full || a.currentSrc || a.src;
          zoomImage.alt = a.alt;
          zoomImage.width = Number(a.getAttribute('width')) || a.naturalWidth;
          zoomImage.height = Number(a.getAttribute('height')) || a.naturalHeight;
          lb.classList.add('is-open');
          lb.removeAttribute('aria-hidden');
          $('button.lightbox__close', lb)?.focus({ preventScroll: true });
        });
        // Preserve the existing click-anywhere-to-close behavior, including the image.
        lb.addEventListener('click', close);
        document.addEventListener('keydown', (e) => {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') { e.preventDefault(); close(); return; }
          if (e.key !== 'Tab' || e.defaultPrevented) return;
          const focusable = $$('a[href], button:not([disabled]), [tabindex="0"]', lb)
            .filter(el => el.getClientRects().length && !el.closest('[hidden], [inert]'));
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (!first) return;
          if (e.shiftKey && (document.activeElement === first || !lb.contains(document.activeElement))) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && (document.activeElement === last || !lb.contains(document.activeElement))) {
            e.preventDefault(); first.focus();
          }
        });
      }
    }
    renderState();
  }

  /* ---------- Scene switcher (home) ---------- */
  function initScenes() {
    $$('[data-scene]').forEach((sec) => {
      const tabs = $$('[role="tab"]', sec), panels = $$('.scene__panel', sec), imgs = $$('.scene__media img', sec);
      const go = (key) => {
        tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.key === key));
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.key === key));
        imgs.forEach((i) => i.classList.toggle('is-active', i.dataset.key === key));
        const t = tabs.find((x) => x.dataset.key === key); if (t && t.dataset.tone) sec.style.setProperty('--scene-from', t.dataset.tone);
      };
      tabs.forEach((t) => t.addEventListener('click', () => go(t.dataset.key)));
      if (tabs[0]) go(tabs[0].dataset.key);
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    const input = $('[data-predictive-input]'), out = $('[data-predictive-results]'); if (!input || !out) return;
    let t, controller, requestVersion = 0;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const version = ++requestVersion, q = input.value.trim();
      controller?.abort(); controller = null;
      if (q.length < 2) { out.innerHTML = ''; out.removeAttribute('aria-busy'); return; }
      out.setAttribute('aria-busy', 'true');
      t = setTimeout(async () => {
        controller = new AbortController();
        try {
          const r = await fetch(PW.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,article,page&resources[limit]=5&section_id=predictive-search', { signal: controller.signal });
          if (!r.ok) throw new Error('Search request failed');
          const html = await r.text();
          if (version !== requestVersion) return;
          const tmp = document.createElement('div'); tmp.innerHTML = html;
          const inner = $('#predictive-search-results', tmp); out.innerHTML = inner ? inner.innerHTML : '';
        } catch (e) {
          if (e.name !== 'AbortError' && version === requestVersion) out.innerHTML = '';
        } finally {
          if (version === requestVersion) { out.removeAttribute('aria-busy'); controller = null; }
        }
      }, 220);
    });
  }

  /* ---------- Tabs (generic) / details close on outside click ---------- */
  document.addEventListener('click', (e) => {
    $$('.facets details[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initReveal(); initRibbons(); initParallax(); initGlow(); initMagnetic(); initCountUp(); initHeader();
    initProduct(); initScenes(); initSearch();
    document.addEventListener('shopify:section:load', () => { initReveal(); initRibbons(); initScenes(); });
  });
})();
